module.exports = __webpack_public_path__ + "static/media/pencil.e1910d2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainPanel/components/TablePart/Table/assets/pencil.svg
// module id = 1952
// module chunks = 0